/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import { mediaHelperMaxWidth } from "@fitinsur/utils/src";

export const IconButton = styled.button`
  display: flex;
  width: 50px;
  height: 50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: flex-end;
  margin: 0px;
  padding: 0;
  margin-bottom: 20px;
`;

export const TotalContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const LabelGroup = styled.div`
  display: flex;
  flex-direction: column;

  width: ${({ width }) => width && `${width}`};

  ${mediaHelperMaxWidth.md`
    width: ${({ tabletWidth }) => tabletWidth && `${tabletWidth}` };
    min-width: ${({ tabletWidth }) => tabletWidth && `${tabletWidth}`};
  `}

  ${mediaHelperMaxWidth.sm`
    width: ${({ mobileWidth }) => mobileWidth && `${mobileWidth}` };
    min-width: ${({ mobileWidth }) => mobileWidth && `${mobileWidth}`};
  `}
`;
